<script>
import { mapState, mapMutations } from 'vuex'
import * as def from '@/lib/definition'
import { fb } from '@/lib/common'
import account from '@/components/account.vue'
import signIn from '@/components/sign-in.vue'
import editor from '@/components/editor.vue'
import loadingScreen from '@/components/loading-screen.vue'

export default {
  components: {
    cmspaAccount: account,
    signIn,
    cmspaEditor: editor,
    loadingScreen
  },
  setup: () => ({ def }),
  computed: {
    ...mapState([
      'user',
      'editor',
      'asyncQueue'
    ]),
    loading () {
      return this.asyncQueue.length
    }
  },
  created () {
    this.enqueueAsync()
    fb.auth().onAuthStateChanged(user => {
      this.dequeueAsync()
      if (user) {
        console.log('User is signed in.')
        this.setUser(user)
      } else {
        console.log('No user is signed in.')
      }
    })
  },
  methods: {
    ...mapMutations([
      'enqueueAsync',
      'dequeueAsync',
      'setUser'
    ])
  }
}
</script>

<template>
  <header class="level is-mobile">
    <router-link :to="{name: 'home'}">
      <h1 class="is-size-1">
        <img src="/titlelogo2nd2.png" alt="TBATE">
        <span class="stg is-size-2"></span>
        <span class="is-size-5 has-text-weight-normal">Powered by FF</span>
      </h1>
    </router-link>
    <cmspa-account/>
  </header>
  <router-view v-if="user"/>
  <sign-in v-else/>
  <transition name="fade">
    <cmspa-editor
      v-if="editor"
      :params="editor"
    />
  </transition>
  <transition name="fade" appear>
    <loading-screen v-if="loading"/>
  </transition>
</template>

<style lang="scss" scoped>
@use "./styles/variables";
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 3rem;
  background-color: variables.$gray-lighter;
  border-bottom: solid 2px grey;
  h1 {
    margin: auto .5rem;
    display: flex;
    align-items: center;
    img {
      height: 2.5rem;
    }
    .stg {
      padding: 0 .5rem;
    }
  }
}
</style>
